import {getAppDiscriminator} from "util/AppName"
import {LocalStorageUtil} from 'util/LocalStorageUtil';
import {getCurrentUserId} from 'module/SessionInfo/api/SessionInfoAPI';

function getUser() {
	return getCurrentUserId();
}

function getScoped(key) {
	return [getUser(), getAppDiscriminator(), key].join('_');
}

export function save(key, value) {
	LocalStorageUtil.save(getScoped(key), value)
}

export function load(key) {
	return LocalStorageUtil.load(getScoped(key));
}